import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="fixed top-4 right-4 z-50">
      <button
        onClick={() => setLanguage(language === 'fr' ? 'en' : 'fr')}
        className="bg-white/80 backdrop-blur-sm hover:bg-white text-gray-800 px-4 py-2 rounded-full 
                 shadow-lg flex items-center gap-2 transition-all hover:shadow-xl"
      >
        <Globe className="w-4 h-4" />
        <span className="font-medium">{language === 'fr' ? 'EN' : 'FR'}</span>
      </button>
    </div>
  );
}